import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { shouldUseAnchorForLink } from "@faire/web--source/ui/lib";
import { Anchor, Link } from "@faire/web--source/ui/LinkAnchor";
import { useHistory } from "react-router-dom";
export var useGetAttributes = function useGetAttributes(props) {
  var linkTo = props.linkTo;
  var history = useHistory();
  if (linkTo === undefined) {
    return {
      as: "button",
      linkProps: {}
    };
  }
  if ("download" in props || shouldUseAnchorForLink(linkTo)) {
    var descriptor = typeof linkTo === "function" ? linkTo(history.location) : linkTo;
    var resolved = typeof descriptor === "string" ? descriptor : history.createHref(descriptor);
    return {
      as: Anchor,
      linkProps: {
        href: resolved
      }
    };
  }
  return {
    as: Link,
    linkProps: {
      to: linkTo,
      replace: props.replace
    }
  };
};
export var extendBaseThemeVariant = function extendBaseThemeVariant(baseTheme, extendedTheme) {
  return function (props) {
    var baseThemeComputed = typeof baseTheme === "function" ? baseTheme(props) : baseTheme;
    var extendedThemeComputed = typeof extendedTheme === "function" ? extendedTheme(props) : extendedTheme;
    return _objectSpread(_objectSpread({}, baseThemeComputed), extendedThemeComputed);
  };
};